import { Capacitor } from '@capacitor/core'

export const isiOS = (): boolean => {
  return (
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream
  )
}

export const isIOSDevice = (): boolean => {
  const platform = Capacitor.getPlatform()
  if (platform === 'web') {
    const userAgent = navigator.userAgent || navigator.vendor
    return /iPad|iPhone|iPod/.test(userAgent)
  } else {
    return platform === 'ios'
  }
}
